<template>
  <div class="meter">
    <svg :viewBox="`0 0 ${W} ${H}`" class="chart">
      <!-- track -->
      <rect :x="PAD.l" :y="trackY" :width="W - PAD.l - PAD.r" :height="8" class="track" />
      <!-- current fee lever fill -->
      <rect :x="PAD.l" :y="trackY" :width="Math.max(0, x(Math.min(current, maxPts)) - PAD.l)" :height="8" class="fill" />
      <!-- markers -->
      <g v-for="m in shown" :key="m.key">
        <line :x1="x(m.value)" :x2="x(m.value)" :y1="trackY - 8" :y2="trackY + 16" class="marker" :class="{ 'marker-red': m.hot }" />
        <text
          :x="labelX(m)" :y="m.lane === 0 ? trackY - 26 : trackY - 14"
          class="m-label" :class="{ 'm-label-red': m.hot }" :text-anchor="anchor(m)"
        >+{{ m.value.toFixed(m.value >= 10 ? 1 : 2) }}% — {{ m.label }}</text>
      </g>
      <!-- axis -->
      <text v-for="t in ticks" :key="`t${t}`" :x="x(t)" :y="H - 6" class="tick" text-anchor="middle">{{ t }}%</text>
    </svg>
  </div>
</template>

<script>
import { scaleLinear } from '../../utils/chartUtils';

export default {
  name: 'BreakEvenMeter',
  props: {
    current: { type: Number, required: true }, // fee lever setting (%)
    markers: { type: Array, required: true }, // [{key,value,label,hot,lane}]
    maxPts: { type: Number, default: 15 },
  },
  data: () => ({ W: 1000, H: 96, PAD: { l: 16, r: 16 } }),
  computed: {
    trackY() { return 56; },
    x() { return scaleLinear([0, this.maxPts], [this.PAD.l, this.W - this.PAD.r]); },
    ticks() {
      const out = [];
      for (let t = 0; t <= this.maxPts; t += 5) out.push(t);
      return out;
    },
    shown() { return this.markers.filter((m) => m.value >= 0 && m.value <= this.maxPts); },
  },
  methods: {
    anchor(m) {
      const px = this.x(m.value);
      if (px < 180) return 'start';
      if (px > this.W - 180) return 'end';
      return 'middle';
    },
    labelX(m) {
      const px = this.x(m.value);
      if (px < 180) return Math.max(px - 6, this.PAD.l);
      if (px > this.W - 180) return px + 6;
      return px;
    },
  },
};
</script>

<style scoped>
.chart { width: 100%; height: auto; display: block; }
.track { fill: var(--track); }
.fill { fill: var(--red); }
.marker { stroke: var(--ink); stroke-width: 1.5; }
.marker-red { stroke: var(--red); }
.m-label { font-size: 11.5px; font-weight: 700; fill: var(--ink); }
.m-label-red { fill: var(--red); }
.tick { font-size: 10.5px; fill: var(--muted); font-variant-numeric: tabular-nums; }
</style>
